import React from 'react';
import Header from '../common/header';
import Footer from '../common/footer';
import ContactPage from '../layout/contact/contactpage';
import About1 from '../layout/about/about1';


function Maincontact(){
    return(
        <div>
            <Header/>
            <br/>
            <ContactPage/>
            <br/>
            <Footer/>
        </div>
    )
}
export default Maincontact;